import React from 'react';
import { Card, Checkbox } from 'semantic-ui/semantic-ui-imports';
import { AddonOption, AddonCategory } from '../../Types/Aggregates';
import './index.scss';

interface Props {
  categories: Array<AddonCategory>;
  selectedAddons: Array<AddonOption>;
  onSelect: (addon: AddonOption) => void;
  onDeselect: (addon: AddonOption) => void;
}

const AddonForm = ({
  categories,
  selectedAddons,
  onSelect,
  onDeselect,
}: Props) => {
  const isSelected = (addon: AddonOption) =>
    selectedAddons.some((a) => a.id === addon.id);

  const onChange = (event: any, addon: AddonOption) => {
    const isChecked = event?.target?.checked;
    if (isChecked) {
      onSelect(addon);
    } else {
      onDeselect(addon);
    }
  };

  return (
    <div className="addon-form">
      {categories.map((cat: AddonCategory) => (
        <div className="addon-form__category" key={cat.id}>
          <h4>{cat.name}</h4>
          {cat?.addons?.map((option: AddonOption) => (
            <Card className="addon-form__category__option" key={option.id}>
              <Card.Content>
                <Card.Header className="addon-form__category__option-header">
                  <span>{option.name}</span>
                  <Checkbox
                    id={option.name}
                    type="checkbox"
                    name={option.name}
                    value={option.sku}
                    checked={option.mandatory || isSelected(option)}
                    disabled={option.mandatory}
                    onChange={(e: any) => onChange(e, option)}
                  />
                </Card.Header>
                {/* {
                  !!option.image && 
                  <img width="100%" src={option.image} />
                } */}
              </Card.Content>
            </Card>
          ))}
        </div>
      ))}
    </div>
  );
};

export default AddonForm;
